import { borderRadius } from '@core-ds/primitives';

export default {
   sm: borderRadius.sm,
   md: borderRadius.md,
   lg: borderRadius.lg,
   xl: borderRadius.xl,
   base: borderRadius.md,
   full: borderRadius.pill,
};
